import { useLocation } from "@reach/router"
import { useMemo } from "react"

export function useLocationQuery() {
  const location = useLocation()
  return useMemo(() => {
    return new URLSearchParams(location.search)
  }, [location])
}
